import { render, staticRenderFns } from "./HotelDetailsEmptyState.vue?vue&type=template&id=23478bbb&"
import script from "./HotelDetailsEmptyState.vue?vue&type=script&lang=js&"
export * from "./HotelDetailsEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports